import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function CtaSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20" aria-labelledby="cta-title">
      <div className="max-w-6xl mx-auto rounded-lg bg-primary-600 px-6 md:px-12 py-12 md:py-16 text-center">
        <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs font-label">
          <i className="ri-shield-keyhole-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          这一年，已有 3.8 万条线索从这里出发
        </span>
        <h2 id="cta-title" className="mt-5 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
          有料想曝，就放心投
        </h2>
        <p className="mt-4 text-sm md:text-base text-primary-50/90 leading-relaxed max-w-2xl mx-auto">
          不用组织语言，不用解释自己是谁。写下你知道的事，剩下的交给我们。
          你也可以先浏览线索库，看看别人是怎么投的。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/submit"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-background-50 text-primary-700 text-sm md:text-base font-label font-medium whitespace-nowrap hover:bg-accent-100 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-fill w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            前往投稿通道
          </Link>
          <a
            href={`mailto:${siteInfo.email}`}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-50/40 text-background-50 text-sm md:text-base font-label font-medium whitespace-nowrap hover:bg-background-50/15 transition-colors cursor-pointer"
          >
            <i className="ri-mail-send-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            发送到编辑邮箱
          </a>
        </div>
      </div>
    </section>
  );
}